import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {ProjectCloneTreeButtonProps} from "./project-clone-tree-button.types"
import {CLONE_TREE_MUTATION} from "./project-clone-tree-button.graphql";
import {getTreeEditorPath} from "../../../../app/routes/GraphEditorRoutes";
import {
    projectCloneTreeButton_CloneTreeUsingAPredefinedTemplateAdminMutation
} from "../../../../__generated__/projectCloneTreeButton_CloneTreeUsingAPredefinedTemplateAdminMutation.graphql";
import {CreateTreeForm} from "../../../../app/components/tree/tree/create-tree-form";
import {CreateTreeFormState} from "../../../../app/components/tree/tree/create-tree-form/create-tree-form.types";

export const ProjectCloneTreeButton = ({
                                           rootNodeId,
                                           rootNodesConnectionId,
                                           className,
                                       }: ProjectCloneTreeButtonProps) => {
    const [cloneTree, isCloningTree] =
        useMutation<projectCloneTreeButton_CloneTreeUsingAPredefinedTemplateAdminMutation>(
            CLONE_TREE_MUTATION,
        );

    const navigate = useNavigate();
    const [displayMaximizable, setDisplayMaximizable] = useState(false);

    return (
        <>
            <Button
                label={""}
                className={className}
                disabled={isCloningTree}
                icon={"pi pi-copy"}
                tooltip={"Duplizieren"}
                onClick={() => setDisplayMaximizable(true)}
            />

            <CreateTreeForm
                type={"clone"}
                displayMaximizable={displayMaximizable}
                setDisplayMaximizable={setDisplayMaximizable}
                onSubmitCallback={(formValues: CreateTreeFormState) => {
                    cloneTree({
                        variables: {
                            input: {
                                rootNodeId: rootNodeId,
                                title: formValues.title,
                            },
                            connections: [rootNodesConnectionId],
                        },
                        onCompleted: (response) => {
                            navigate(
                                getTreeEditorPath(
                                    response.Admin.Tree.cloneTreeUsingAPredefinedTemplate
                                        ?.clonedRootNode.node.id || "",
                                ),
                            );
                        },
                    });
                }}
                isSubmittingMutation={isCloningTree}
            />
        </>
    );
};
